const NAVY = "#042E45";

const Flag = ({ code, size = 18 }) => (
  <img
    src={`https://flagcdn.com/w40/${code}.png`}
    srcSet={`https://flagcdn.com/w80/${code}.png 2x`}
    alt=""
    loading="lazy"
    className="rounded-[2px] object-cover shrink-0"
    style={{ width: size, height: Math.round(size * 0.72) }}
  />
);

// Indicador estático de cobertura actual (Guatemala). No es un selector: la
// selección de país ocurre en el modal "Contanos de tu país".
export default function CountrySelector() {
  return (
    <span
      data-testid="country-selector"
      className="inline-flex items-center gap-2 text-sm font-semibold px-2 py-2"
      style={{ color: NAVY }}
    >
      <Flag code="gt" />
      <span className="hidden sm:inline">Guatemala</span>
    </span>
  );
}
